import InfoIcon from "@mui/icons-material/InfoOutlined";
import styled from "styled-components/macro";
import { medText } from "constants/colors";
import { useSettings } from "contexts/SettingsManager/SettingsManager";
import PredictedMetricTooltip from "./PredictedMetricTooltip";

export function PredictedMetricIndicator() {
  const { estimatedFutureMetricPercent } = useSettings();
  return (
    <PredictedMetricStyles className="predictedWrapper">
      <div className="predicted">
        (predicted assuming {estimatedFutureMetricPercent * 100}% perf)
      </div>
      <span className="btnHelp">
        <PredictedMetricTooltip>
          <InfoIcon />
        </PredictedMetricTooltip>
      </span>
    </PredictedMetricStyles>
  );
}
const PredictedMetricStyles = styled.div`
  bottom: -16px;
  left: 0;
  right: 0;
  position: absolute;
  line-height: 0.5em;
  font-weight: normal;
  display: flex;
  justify-content: center;
  .predicted {
    white-space: nowrap;
    color: ${medText};
    font-size: 9px;
  }
  .btnHelp {
    pointer-events: auto;
    width: 12px;
    height: 12px;
    top: 0px;
    right: -15px;
    svg {
      opacity: 0.3;
      width: 12px;
      height: 12px;
    }
  }
`;
